






















import Vue from 'vue';
import type { PropOptions } from 'vue';
import HeaderMenuNotificationsCardGrid from '@/components/global/HeaderMenu/HeaderMenuNotifications/HeaderMenuNotificationsCard/HeaderMenuNotificationsCardGrid/HeaderMenuNotificationsCardGrid.vue';
import type { Notification, Post } from '@/types/graphql';

export default Vue.extend({
  name: 'HeaderMenuNotificationsCardOfficialPost',
  components: {
    HeaderMenuNotificationsCardGrid,
  },
  props: {
    notification: {
      type: Object,
      required: true,
    } as PropOptions<Notification>,
  },
  computed: {
    referenceable(): Post {
      return this.notification.referenceable as Post;
    },
    titleClass(): Record<string, boolean> {
      return {
        'header-menu-notifications-card-announcement__title': true,
        'header-menu-notifications-card-announcement__title--read': !!this.notification.readAt,
      };
    },
  },
});
